import { Tooltip } from '@redis-ui/components';
import { InfoIcon } from '@redis-ui/icons';
import * as S from './style';
import { LabelValueItemProps } from './LabelValueItem.types';
import { stringToReadOnlyTestId } from '../../../utils/dataAttributesHelpers';

const LabelValueItem = (props: LabelValueItemProps) => {
  const {
    id,
    direction = 'vertical',
    labelText,
    labelComponent,
    valueComponent,
    valueText,
    betweenMargin,
    testId,
    valueColor,
    className,
    tooltipContent
  } = props;

  return (
    <S.Wrapper direction={direction} className={className}>
      <S.LabelContainer>
        {(labelText || labelComponent) && (
          <S.LabelText htmlFor={id || testId} data-testid={stringToReadOnlyTestId(testId, 'label')}>
            {labelText && !labelComponent ? labelText : labelComponent}
          </S.LabelText>
        )}
        {tooltipContent && (
          <Tooltip content={tooltipContent}>
            <S.InfoIconWrapper>
              <InfoIcon size="L" variant="secondary" />
            </S.InfoIconWrapper>
          </Tooltip>
        )}
      </S.LabelContainer>

      {valueComponent && (
        <S.ValueComponent
          data-testid="value-component"
          direction={direction}
          betweenMargin={betweenMargin}
        >
          {valueComponent}
        </S.ValueComponent>
      )}
      {valueText && (
        <S.ValueText
          data-testid={stringToReadOnlyTestId(testId, 'value')}
          {...{ valueColor, direction, betweenMargin }}
        >
          {valueText}
        </S.ValueText>
      )}
    </S.Wrapper>
  );
};

export default LabelValueItem;
